import React from 'react'
import { GongIcon } from '../../icons/Gong'
import { SlackIcon } from '../../icons/Slack'
import { ZoomIcon } from '../../icons/Zoom'
import { GoogleIcon } from '../../icons/Google'
import { MicrosoftIcon } from '../../icons/Microsoft'
import { UploadIcon } from '../../icons/Upload'

/**
 * MeetingSourceIcon component that displays the appropriate icon for a meeting source
 * with the correct background color
 */
export function MeetingSourceIcon({ source, width = '10', height = '10', ...props }) {
  // Return null if no source is provided
  if (!source) return null

  // Define background colors for different sources
  const getIconConfig = () => {
    switch (source.toLowerCase()) {
      case 'gong':
        return {
          backgroundColor: '#8039E9',
          icon: <GongIcon width={width} height={height} viewBox="0 0 80 100" fill="#FFFFFF" {...props} />,
        }
      case 'slack':
        return {
          backgroundColor: '#FFFFFF',
          icon: <SlackIcon width={width} height={height} {...props} />,
        }
      case 'zoom':
        return {
          backgroundColor: '#2D8CFF',
          icon: <ZoomIcon width={width} height={height} {...props} />,
        }
      case 'teams':
        return {
          backgroundColor: '#0078D4',
          icon: <MicrosoftIcon width={width} height={height} {...props} />,
        }
      case 'google':
        return {
          backgroundColor: '#4285F4',
          icon: <GoogleIcon width={width} height={height} {...props} />,
        }
      case 'upload':
        return {
          backgroundColor: 'transparent',
          icon: <UploadIcon width="24" height="24" {...props} />,
        }
      // Add more cases for other providers as needed
      default:
        return {
          backgroundColor: '#E4E4E4',
          icon: <div className="text-gray-500 font-bold text-[5px]">{source.toUpperCase()}</div>,
        }
    }
  }

  const { backgroundColor, icon } = getIconConfig()

  return (
    <div className="flex items-center justify-center w-5 h-5 rounded-sm" style={{ backgroundColor }}>
      {icon}
    </div>
  )
}